<template>
    <div class="app-main" id="AppMain" :class="{ 'person-scrollbar': $route.name === 'Person' }">
        <div class="app-main-wrap">
            <transition name="fade-transform" mode="out-in">
                <keep-alive>
                    <router-view :key="key" />
                </keep-alive>
            </transition>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from './Footer.vue'
export default {
    name: 'AppMain',
    components: { Footer },
    computed: {
        key() {
            return this.$route.path
        }
    }
}
</script>

<style lang="scss" scoped>
.app-main {
    position: absolute;
    top: 0;
    left: 300px;
    right: 0;
    bottom: 0;
    overflow: auto;
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);

    &.person-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #f59a0b transparent;

        &::-webkit-scrollbar {
            width: .08rem;
            height: .06rem;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: .5rem;
            background: linear-gradient(180deg, #ffd34e 0%, #f59a0b 56%, #d76500 100%);
            box-shadow: inset 0 0 0 1px rgba(255, 232, 155, .28);
        }

        &::-webkit-scrollbar-track {
            border-radius: .5rem;
            background: transparent;
            box-shadow: none;
        }
    }

    .app-main-wrap {
        margin: 0;
        max-width: none;
        min-width: 720px;
        padding-left: 14px;
        padding-right: 14px;
        width: 100%;
        box-sizing: border-box;
    }
}

html[data-device-nodesktop="1"] {
    .app-main {
        max-height: 100vh;
    }
}
html[data-device-nodesktop="0"] {
    .app-main {
        right: 0 !important;
    }
}
</style>
